'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumList = ({ testId, className })=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            jsxRuntime.jsx("path", {
                d: "M4.49023 2.83752H15.0002",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M4.49023 7.50037H15.0002",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M4.49023 12.1632H15.0002",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M2.24 2.83716C2.24 3.00541 2.09265 3.17433 1.87 3.17433C1.64735 3.17433 1.5 3.00541 1.5 2.83716C1.5 2.66891 1.64735 2.5 1.87 2.5C2.09265 2.5 2.24 2.66891 2.24 2.83716Z",
                fill: "currentColor",
                stroke: "currentColor"
            }),
            jsxRuntime.jsx("path", {
                d: "M2.24 7.5C2.24 7.66826 2.09265 7.83717 1.87 7.83717C1.64735 7.83717 1.5 7.66826 1.5 7.5C1.5 7.33175 1.64735 7.16284 1.87 7.16284C2.09265 7.16284 2.24 7.33175 2.24 7.5Z",
                fill: "currentColor",
                stroke: "currentColor"
            }),
            jsxRuntime.jsx("path", {
                d: "M2.24 12.1628C2.24 12.3311 2.09265 12.5 1.87 12.5C1.64735 12.5 1.5 12.3311 1.5 12.1628C1.5 11.9946 1.64735 11.8257 1.87 11.8257C2.09265 11.8257 2.24 11.9946 2.24 12.1628Z",
                fill: "currentColor",
                stroke: "currentColor"
            })
        ]
    });
};

module.exports = MediumList;
